export const gradients = [
    'blue-green',
    'blue-red',
    'indigo-blue',
    'indigo-cyan',
    'indigo-purple',
    'purple-cyan',
    'purple-green',
    'purple-pink',
    'purple-yellow',
    'red-pink',
    'red-yellow',
] as const

export type Gradient = typeof gradients[number]
